/* ------------------------------------------------------------------------
  Copyright (c) 2016, VoiceVibes, Inc

  VoiceVibes, Inc - PROPRIETARY/CONFIDENTIAL
  All contents of this file are proprietary and confidential. No part of
  any of the contents of this file may be disclosed in any manner to
  a third party without the prior written consent of VoiceVibes, Inc.
  Unauthorized copying of this file, via any medium is strictly prohibited.
----------------------------------------------------------------------------- */

<template>
  <div>
    <div v-for="t in transcript">
      <h4
        v-if="isConversational && getHeader(t)"
      >
        {{ getHeader(t) }}
      </h4>
      <span>{{ t.text }}</span>
    </div>
  </div>
</template>

<style lang="less" scoped>
</style>

<script>
export default {
  props: ['recording'],
  computed: {
    isConversational() {
      return !!(this.recording && this.recording.results && this.recording.results.isConversational);
    },
    transcript() {
      // TODO: When we add support for clickable word links, this data structure will need
      // to change entirely
      // Check for the transcript in transcriptOnly mode first
      const diarizedTranscript = this.recording.diarizedTranscript ?
        this.recording.diarizedTranscript.transcription : this.recording.results.diarizedTranscript;
      let transcript = this._.cloneDeep(diarizedTranscript);
      let transcript2 = [];

      for (let i=0; i<transcript.length; i++) {
        const word = transcript[i];
        if (!transcript2.length) {
          transcript2.push(word);
          continue;
        }
        const last = transcript2[transcript2.length-1];
        if (last.speaker === word.speaker) {
          // Support for transcriptOnly vs. Regular
          if (!last.text) last.text = ''; // hack
          const space = word.isPunctuation || (word.type && word.type === 'punctuation') ?
            '' : ' ';
          const text = word.alternatives && word.alternatives[0] ? word.alternatives[0].content : word.text;
          if (text) last.text += `${space}${text}`;
        } else {
          transcript2.push(word);
        }
      }

      return transcript2;
    }
  },
  methods: {
    getHeader(word) {
      return (this.recording.speakerNum - 1 == word.speaker) ?
        this.recording.userFirstName : `Speaker ${word.speaker + 1}`;
    }
  }
};
</script>
